export default "__VITE_ASSET__CSmq1h73__"